import { render, staticRenderFns } from "./myInquiryListItem.vue?vue&type=template&id=264db1a3&scoped=true"
import script from "./myInquiryListItem.vue?vue&type=script&lang=js"
export * from "./myInquiryListItem.vue?vue&type=script&lang=js"
import style0 from "./myInquiryListItem.vue?vue&type=style&index=0&id=264db1a3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264db1a3",
  null
  
)

export default component.exports